import { ErrorBanner } from '@patchbay/ui'
import { formatWhen } from '../../lib/display-time'
import { ApiError } from './api'

export function readableTime(value: string | null): string {
  if (!value) return 'No completed call recorded'
  const parsed = new Date(value)
  return Number.isNaN(parsed.valueOf()) ? value : formatWhen(value, { style: 'absolute' })
}

export function compactJson(value: Record<string, unknown> | null): string {
  if (!value) return '—'
  const text = JSON.stringify(value)
  return text.length > 120 ? `${text.slice(0, 117)}…` : text
}

export function MutationError({ error }: { error: Error | null }) {
  if (!error) return null
  const detail = error instanceof ApiError && error.code ? `${error.message} (${error.code})` : error.message
  return <ErrorBanner title="The change was not saved" detail={detail} />
}

export const selectClass =
  'h-8 min-w-0 rounded-md border border-input bg-card px-2.5 text-sm text-foreground outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/25'
